// Everything the site header owns. The object path mirrors the directory path,
// so header/sticky_controller.js is reached as header.StickyController and
// registers as "header--sticky".
import StickyController from "./sticky_controller";

export default { StickyController };
